import styled from "@emotion/styled";

export const ImpactFundTileBadge = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  width: 36px;
  height: 36px;
  background-image: url("/images/app/forest/impact-fund-tile-badge.svg");
  background-repeat: no-repeat;
  background-size: contain;

  @media ${({ theme }) => theme.bp.tabletUp} {
    width: 48px;
    height: 48px;
  }
`;
